
import { getToken, setToken, removeToken, handleUser } from '@/utils/auth'
import { appList } from '@/api/login'
import common from '@/utils/common'

// 获取 app 列表
const getAppList = () => {
  return new Promise((resolve, reject) => {
    appList({}).then(result => {
      resolve(result)
    })
  })
}

const _appList = handleUser.get('appList') || []

// 筛选当前 APP
const filterApp = data => {
  let _app = {}
  const _local = common.getQueryString('weChat')
  // 优先取头部的
  if (_local) {
    let _rows = data.filter(item => item.app_id == _local)
    _app = _rows[0]
  } else {
    // 默认取最后一个
    _app = data[data.length - 1]
  }

  return _app || {}
}

const user = {
  state: {
    token: getToken(),
    userInfo: handleUser.get('userInfo') || {},
    appList: _appList,
    currentApp: filterApp(_appList),
    roles: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERINFO: (state, userInfo) => {
      handleUser.set('userInfo', userInfo)
      state.userInfo = userInfo
    },
    SET_APPLIST: (state, appList) => {
      handleUser.set('appList', appList)
      state.appList = appList
    },
    SET_CURRENTAPP: (state, data) => {
      state.currentApp = data
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise(async (resolve, reject) => {
        const tokenStr = userInfo.token
        setToken(tokenStr)
        commit('SET_TOKEN', tokenStr)
        commit('SET_USERINFO', userInfo)
        try {
          await getAppList().then(appList => {
            handleUser.set('appList', appList)
            commit('SET_APPLIST', appList)
            commit('SET_CURRENTAPP', filterApp(appList))
          })
        } catch (error) { }
        resolve()
      })
    },
    // 刷新 app 列表
    RefreshApp({ commit }, userInfo) {
      return new Promise(async (resolve, reject) => {
        try {
          await getAppList().then(appList => {
            handleUser.set('appList', appList)
            commit('SET_APPLIST', appList)
            commit('SET_CURRENTAPP', filterApp(appList))
            resolve()
          })
        } catch (error) { }
      })
    },
    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        handleUser.remove('userInfo')
        handleUser.remove('appList')
        handleUser.remove('token')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js